import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { UserService } from '@core/services/user.service';
import { AccountComponent } from './components/account/account.component';

@Component({
  selector: 'app-profile',
  imports: [CommonModule, LoginComponent, AccountComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  public _userService = inject(UserService);

  public isMenuOpen = false;

  public closeMenu() {
    this.isMenuOpen = false;
  }

  public toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

}
